import DeleteMessage from "./DeleteMessage";

export default DeleteMessage